import client from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"
import {CreateMagicLoginResponse, MagicLoginResponse} from "@irati/types"

import magicLoginQuery, {magicLoginKey} from "./queries/magicLogin"
import createMagicLoginMutation, {createMagicLoginKey} from "./mutations/createMagicLogin"
import magicErrorHandler from "./errors/magicErrorHandler"

class MagicLogin extends PBService {
  async magicLogin(uuid: string, identifier: string, code: string): Promise<MagicLoginResponse> {
    const variables = {uuid, identifier, code}
    const {data} = await client.query({query: magicLoginQuery, variables, fetchPolicy: "network-only"})
    return data[magicLoginKey]
  }
  async createMagicLogin(identifier: string): Promise<CreateMagicLoginResponse> {
    const variables = {identifier}
    const {data} = await client.mutate({mutation: createMagicLoginMutation, variables, fetchPolicy: "no-cache"})
    return data[createMagicLoginKey]
  }
}

const MagicLoginService = new MagicLogin({errorHandlers: [magicErrorHandler]})

export default MagicLoginService
